import { cn } from "@app/lib/utils";
import { URLS } from "@app/shared";
import { PageHeader } from "@design-system/components";
import { PressRelease } from "@modules/press-releases/type";
import { getLocalizedValue } from "@modules/shared/utils";
import { readMoreWords } from "@mongez/reinforcements";

export function PressReleaseDetailsPage({
  pressRelease,
}: {
  pressRelease: PressRelease;
}) {
  return (
    <>
      <PageHeader
        image={getLocalizedValue(pressRelease.breadcrumbImage)}
        breadcrumbItems={[
          {
            label: "home",
            link: URLS.home,
          },
          {
            label: "pressReleases",
            link: URLS.pressReleases.root,
          },
          {
            label: readMoreWords(getLocalizedValue(pressRelease.title), 5),
            link: URLS.pressReleases.view(pressRelease.id),
          },
        ]}
        contentClassName="!max-w-full"
        translationKey="pressReleases"
        imageClassName="rounded-[40px] ltr:rounded-r-none rtl:rounded-l-none rtl:scale-x-1"
        className="max-lg:pb-12"
      ></PageHeader>
      <div className="relative bg-[#f7f9fc] py-10 text-marine sm:py-16 lg:py-20">
        <div className="container relative z-20 flex w-full justify-center">
          <div className="max-w-[1200px]">
            <div
              dangerouslySetInnerHTML={{
                __html: getLocalizedValue(pressRelease.content),
              }}
              className={cn(
                "quarterly-report-content prose max-w-full justify-center font-medium prose-table:rounded-xl odd:prose-tr:bg-gray-100 first-of-type:prose-tr:bg-marine first-of-type:prose-tr:text-white prose-td:border prose-td:border-marine prose-td:p-2 prose-td:text-[10px] first-of-type:prose-td:min-w-[150px] prose-td:sm:text-xs prose-td:lg:text-sm",
                // "[&_table]:[direction:ltr] [&_td]:rtl:[direction:rtl]",
                "flex flex-col gap-1 text-sm leading-6 prose-h2:mb-0 prose-h2:text-2xl prose-h2:font-bold prose-h2:text-primary prose-h3:mb-0 prose-h3:text-lg prose-h3:font-bold prose-h3:text-bright-orange prose-h4:mb-0 prose-h4:text-lg prose-h4:font-bold prose-h4:text-bright-orange prose-p:mb-0 prose-ul:flex prose-ul:list-disc prose-ul:flex-col prose-ul:gap-3 sm:gap-2 sm:text-lg prose-h2:sm:text-3xl prose-h3:sm:text-xl prose-h4:sm:text-xl lg:gap-4 lg:text-xl prose-h2:lg:text-4xl prose-h3:lg:text-2xl prose-h4:lg:text-2xl ltr:prose-li:ml-5 ltr:sm:prose-li:ml-10 rtl:prose-li:mr-5 rtl:sm:prose-li:mr-10",
              )}
            />
          </div>
        </div>
      </div>
    </>
  );
}
